import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as NoCardSelectionIcon } from '../../../images/icons/no_selection_card_icon.svg';
import { darkPurple, dimGrey } from '../../../mainTheme';

const NoSelectionCard = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box sx={{ mb: '24px', mt: '24px' }}>
        <NoCardSelectionIcon />
      </Box>
      <Typography
        gutterBottom
        sx={{
          color: darkPurple,
          fontSize: '18px',
          fontWeight: 500,
          lineHeight: '24px',
          letterSpacing: '0.2px',
        }}
      >
        Select a card
      </Typography>
      <Typography
        sx={{
          color: dimGrey,
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: '0.2px',
        }}
        mb={2}
      >
        Select a card above to view more information.
      </Typography>
    </Box>
  );
};

export default NoSelectionCard;
